import type { FaireCategoryEntity } from "@faire/playground-entity-db/entity_types/category";
import { getEntityByToken } from "../get_entity";

const ROOT_CATEGORY_TOKENS = [
  "cat_holidays-seasonal",
  "cat_brand-values",
  "cat_featured-brands",
  "cat_gifts",
  "cat_home-decor",
  "cat_beauty-wellness",
  "cat_food-drink",
  "cat_paper-novelty",
  "cat_pets",
  "cat_apparel",
  "cat_accessories",
  "cat_footwear",
  "cat_jewelry",
  "cat_kids-baby",
];

export const rootCategories: FaireCategoryEntity[] = ROOT_CATEGORY_TOKENS.map(
  (token) => getEntityByToken(token, "category")
).filter(
  (
    category: FaireCategoryEntity | undefined
  ): category is FaireCategoryEntity => category !== undefined
);
